import React from "react";
import {GearTeamMember, Theme} from "../Other/Types";
import {getString} from "../Language/LanguageHandler";
import UserCard from "../Components/UserCard";

type MeetTheTeamProps = {
    pageWidth: number;
    theme: Theme;
};

type MeetTheTeamState = {};
const teams = [
    {
        name: "Core Team",
        description: "The core team responsible for most of the heavy lifting in making sure the gears keep turning smoothly.",
        key: "core"
    },
    {
        name: "Contributors",
        description: "These people helped to make GearBot even better.",
        key: "contributors"
    },
    {
        name: "Website",
        description: "The team that made this amazing website.",
        key: "website"
    },
    {
        name: "Website design",
        description: "Made the amazing design for this website.",
        key: "design"
    },
    {
        name: "Emoji Design",
        description: "People who made the amazing emoji GearBot uses.",
        key: "emoji"
    }
];
export default function MeetTheTeam() {
//    const {isLoading, error, data} = useQuery('teamMembers', () =>
//        fetch(getApiUrl('team_info')).then(res =>
//            res.json()
//        ));
//
//    if (isLoading) {
//        return (<LoadingScreen/>)
//    }
//    if (error)
//        console.log(error)

	const data = [
        {
            team: "core",
			username: "aenterprise",
			discriminator: "",
			id: "106354106196570112",
			avatar: "a_830b0d2082e9b84d00816eae9324d29e",
			socials: {
                github: "AEnterprise",
				twitter: "AEnterprise1"
            }
        },
		{
            team: "core",
            username: "blackholefox",
			discriminator: "",
			id: "105076359188979712",
			avatar: "dd515744bfad11d09c5ecdecda1bf066",
			socials: {
                github: "BlackHoleFox"
            }
        },
		{
            team: "contributors",
            username: "tfarkas",
			discriminator: "",
			id: "128181551472050176",
            avatar: "29902a7540c170b1a2552d67f177e397",
			socials : {
                github: "trilleplay",
				twitter: "TristanAtFarkas"
            }
        },
		{
            team: "contributors",
            username: "shinysprigatito",
			discriminator: "",
			id: "298618155281154058",
			avatar: "a_0c6d6f79319dffebcfdab96102bc7d14",
			socials: {
                github: "Kitty-Therapist"
            }
        },
		{
            team: "contributors",
            username: "mrkirby153",
			discriminator: "",
			id: "117791909786812423",
            avatar: "7b1a163e682cc6f86b97fb377fec7f0e",
			socials: {
                github: "mrkirby153",
				twitter: "mrkirby153"
            }
        },
		{
            team: "website",
            username: "johnythecarrot",
			discriminator: "",
			id: "132819036282159104",
			avatar: "c23c700b552efb10aa5ef6c68c820b06",
			socials: {
                github: "JohnyTheCarrot",
				twitter: "JohnyTheCarrot"
            }
        },
		{
            team: "design",
            username: "shuu",
			discriminator: "",
			id: "82993510503944192",
            avatar: "a1a4ad044a68f54584c70c1c56f9a705",
			socials: {
				twitter: "shuuwastaken"
            }
        },
		{
            team: "emoji",
            username: "vanishedvan",
			discriminator: "9049",
			id: "267025484028706816",
            avatar: "bbb5ada8126d62ce2ac5f8312d851ca0",
			socials: {
                github: "vanishedvan",
				twitter: "vanishedvan"
            }
        }
    ]

    return (
        <div className="page-meet-the-team">
            <h1>{getString("meet_the_team")}</h1>
            {
                teams.map(({name, description, key}) => {
                    console.log(name);
                    return (
                        <div key={`team-${name}`}>
                            <h2>{name}</h2>
                            <p>{description}</p>
                            <div className="team-members">

                            {data.filter((member: { team: string; }) => member.team === key).map((member: GearTeamMember, index: number) => {
                                return (
                                    <UserCard user={member} key={`usercard-${index}`}/>
                                );
                            })
                            }
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
